import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Typography from "@mui/material/Typography";
import Stack from "@mui/material/Stack";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";
import { useMutation } from "react-query";
import { OrganizationAdminService } from "gen/clients/llts";
import { ApiErrorMessage } from "components/ApiErrorMessage/ApiErrorMessage";
import { LoadingButton } from "components/LoadingButton/LoadingButton";
import { useTranslation } from "react-i18next";

interface Props {
  firstName?: string;
  lastName?: string;
  username: string;
  clientContactId: number;
  onClose: () => void;
  onSuccess: () => void;
}

const DisableAccountDialog: React.FC<Props> = ({
  username,
  clientContactId,
  firstName,
  lastName,
  onClose,
  onSuccess
}) => {
  const { t } = useTranslation();
  const { mutate, isLoading, error } = useMutation(OrganizationAdminService.disableAccount);

  const onDisableAccountClick = React.useCallback(() => {
    mutate(
      {
        clientContactId,
        requestBody: {
          username
        }
      },
      { onSuccess }
    );
  }, [clientContactId, mutate, onSuccess, username]);

  return (
    <Dialog open={true} onClose={onClose} fullWidth={true} maxWidth="xs">
      <DialogTitle>{t("organizationUsers.disableAccount")}</DialogTitle>
      <DialogContent>
        <Stack spacing={2}>
          <Typography>{t("organizationUsers.disableAccountConfirm", { firstName, lastName })}</Typography>
          {error && <ApiErrorMessage apiError={error} />}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={isLoading}>
          {t("common.cancel")}
        </Button>
        <LoadingButton isLoading={isLoading} onClick={onDisableAccountClick} variant="contained" color="error">
          {t("organizationUsers.disableAccount")}
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};

export { DisableAccountDialog };
